import _ from 'underscore';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import short_sha from '@/lib/short_sha';
import Moment from 'moment';
import IdeSettingsDialog from '@/views/dialogs/ide_settings';
import PaginatedMenuView from '@/views/paginated_menu_view';
import template from '@/../templates/editor-toolbar.hbs';
import deployment_template from '@/../templates/deployment-menu.hbs';
import deployments_dropdown_template from '@/../templates/deployments-dropdown-menu.hbs';
import deployments_item_template from '@/../templates/deployments-item.hbs';
var globalCh = Radio.channel('global');
var alertsCh = Radio.channel('alerts');
var apiCh = Radio.channel('api');
var ga = globalCh.request('app_options', 'ga_account');
import moment from 'moment-timezone';

function show_syntax_success() {
    alertsCh.request('showAlert', {
        messageType: 'success',
        message: 'Your code syntax checks out.'
    });
}

// Handles warnings and error alerts
function show_syntax_failure(message, type) {
    var error_msg;
    if (message === undefined) {
        error_msg = "There's a problem with your code. Fix it and try again!";
    } else {
        error_msg = "There's a problem with your code: " + message;
    }

    type = type || 'danger';
    (type === 'error') ? type = 'danger' : type;

    alertsCh.request('showAlert', {
        messageType: type,
        message: error_msg
    });
}

var DeploymentsDropdownView = PaginatedMenuView.extend({
    template: Handlebars.compile(deployments_dropdown_template),
    childViewOptions: _.extend({}, PaginatedMenuView.prototype.childViewOptions, {
        template: Handlebars.compile(deployments_item_template),
        templateContext: function() {
            var devicegroup = this.model.rel.get('devicegroup');
            var is_draft = false;
            var is_min = false;
            var is_current = false;
            var creator = false;
            if ( this.model.type === 'draft') {
                devicegroup = apiCh.request('development_devicegroup', this.model.id);
                is_draft = true;
            }
            let minimum_deployment = devicegroup.rel.get('min_supported_deployment');
            let current_deployment = devicegroup.rel.get('current_deployment');

            if ( current_deployment && current_deployment.id === this.model.id ) {
                is_current = true;
            }

            if ( minimum_deployment && minimum_deployment.id === this.model.id ) {
                is_min = true;
            }

            if (!is_draft) {
                creator = this.model.rel.get('creator');
                creator = creator.get('username');
            }

            return {
                is_draft: is_draft,
                is_min: is_min,
                is_current: is_current,
                creator: creator,
            };
        }
    }),
    handle_selected_child: function(child_model) {
        if (child_model.type === 'draft') {
            this.set_menu_title("Draft");
            if (ga) {
                window.ga('send', 'event', 'codeEditor', 'Changed Deployment', 'draft');
            }
        } else {
            this.set_menu_title(short_sha(child_model.get('sha')));

            if (ga) {
                window.ga('send', 'event', 'codeEditor', 'Changed Deployment', 'deployment');
            }
        }
        this.set_selected_child(child_model.id);
        this.trigger('select', child_model);

        // Open deployment view for this model

        globalCh.request('showCodeEditor', child_model, this.getOption('devicegroup'), this._parent._parent.device);
    },
    onRender: function() {
        this.show_view_more();
        this.set_selected_child(this.getOption('selected'));
    },
    set_selected_child: function(id) {
        this.selected_child = this.collection.get(id);
        this.children.each(function(child){
            if (child.model.get('id') === id) {
                child.$('a').addClass('active');
            }
        });
    },
    viewComparator: function (model) {
        var timestamp = Moment(model.get('created_at'));
        return -Number(timestamp.format('x'));
    }
});

var CodeInfoView = Marionette.View.extend({
    template: Handlebars.compile(template),
    className: 'editor-toolbar',
    ui: {
        timestamp: '.code-metadata > .timestamp',
        ide_settings: '.settings',
        edit: '.edit',
        check_syntax: '.check-syntax',
        promote: '.promote',
        promote_tooltip: '.promote-tooltip',
        toggle_fullscreen: '.fullscreen',
        state_editable_buttons: 'button.state-editable',
        title: '.editor-title',
        title_subtext: '.title-subtext',
        subtitle: '.secondary-text',
        draft_link: '.draft-link',
        deployment_button: 'button.deployment',
        deployments_dropdown: '.deployments-menu-paginated', // new deployment menu,
        build: '.deployment-menu'
    },
    regions: {
        'deployment': '@ui.build',
        'deployments_dropdown': '@ui.deployments_dropdown'
    },
    events: {
        'click @ui.edit': 'on_click_edit',
        'click @ui.check_syntax': 'check_syntax',
        'click @ui.ide_settings': 'show_ide_settings',
        'click @ui.promote': 'promote',
        'click @ui.toggle_fullscreen': 'toggle_fullscreen',
    },
    templateContext: function() {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        var devicegroup = this.getOption('devicegroup');
        // Application Workspace code editor and Pre-Factory Workspace code editor have different permissions
        var show_promote = false;
        switch (devicegroup.type) {
            case 'development_devicegroup':
                show_promote = active.permits(primary, 'update_development_deployment');
                break;
            case 'pre_factoryfixture_devicegroup':
                show_promote = active.permits(primary, 'update_pre_factory_deployment');
                break;
            case 'pre_production_devicegroup': 
                show_promote = active.permits(primary, 'update_pre_production_deployment');
                break;
            case 'pre_dut_devicegroup':
                show_promote = active.permits(primary, 'update_pre_factory_deployment');
                break;
            default:
                break;
        }
        return {
            show_promote: show_promote,
            is_draft: this.model.type === 'draft'
        };
    },
    initialize: function(options) {
        this.mergeOptions(options, ['devicegroup', 'device']);
        this.is_fullscreen = this.options.settings.get('fullscreen');
        this.listenTo(this.model, 'change:created_at', function () {
            this.update_timestamp(this.model);
            // Re-render this if the model changes so it picks up the update devicegroup data
            this.show_deployments_dropdown();
        });
    },
    onRender: function() {
        this.device = this._parentView().active_device;
        this.show_deployments_dropdown();
        this.set_deployment(this.model.type === 'deployment' ? this.model : this.getOption('devicegroup').rel.get('current_deployment'));
        this.start_code_change_listeners();
        var self = this;
        // These are in an expected order
        var deployment_items = [
            {
                id: 2,
                type: 'deployment_item',
                name: 'Build',
                action: function(){
                    self.build();
                },
            },   
        ];
        if (this.devicegroup.type !== 'pre_dut_devicegroup') {
            deployment_items.splice(0, 0, {
                id: 0,
                type: 'deployment_item',
                name: 'Build and Force Restart',
                action: function () {
                    self.build_and_deploy();
                }
            });
            deployment_items.splice(1, 0, {
                id: 1,
                type: 'deployment_item',
                name: 'Build and Conditional Restart',
                action: function () {
                    self.build_and_conditional_deploy();
                }
            });
        }
        var DeploymentMenu = PaginatedMenuView.extend({
            disable: function (disable) {
                PaginatedMenuView.prototype.disable.call(this, disable);
                if (_.isUndefined(disable)) { disable = true; }
                if (disable) {
                    this.disabled = true;
                    this.$el.find('.menu-title').addClass('disabled');
                    this.$el.find('.menu-title').prop('disabled', true);
                } else {
                    this.disabled = false;
                    this.$el.find('.menu-title').removeClass('disabled');
                    this.$el.find('.menu-title').prop('disabled', false);
                }
            }
        });
        var deployment_menu = new DeploymentMenu({
            template: Handlebars.compile(deployment_template),
            title: deployment_items[0].name,
            collection: new Backbone.Collection(deployment_items),
            model: this.model
        });
        deployment_menu.on('select', function(model){
            if (!model) {
                model = this.selected_child;
            }
            if (!this.disabled) {
                model.get('action').call(self);
            }
            /*
            * Google Analytics (GA) Integration
            * Pass a pageview event if there is a ga_account
            * specified in the config. We don't attempt to
            * validate this at all beforehand. If you get an
            * error from GA, then, check the account id
            * passed from the config.
            */
            if (ga) {
                window.ga('send', 'event', 'codeEditor', 'build', model.get('name'));
            }
        });
        // This button was holding onto focus for some reason, on click. 
        // Don't worry, this still allows keyboard navigation.
        deployment_menu.$el.on('mouseup', function(){
            deployment_menu.$el.find('button').blur();
        });
        deployment_menu.set_selected_child(deployment_items[0].id);
        this.showChildView('deployment', deployment_menu);
    },
    show_deployments_dropdown: function() {
        var devicegroup = this.getOption('devicegroup');
        var deployments = apiCh.request('deployment');
        var title = short_sha(this.model.get('sha'));
        var code_info_view = this;
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        // draft does not need to show SHA
        if (this.model.type === 'draft') {
            title = 'Draft';
        }

        var show_menu = function(result) {
            if (code_info_view.isDestroyed()) return;
            // Options for childView depend on the current model
            var deployment_dropdown = new DeploymentsDropdownView({
                devicegroup: devicegroup,
                model: devicegroup,
                title: title,
                selected: code_info_view.model.get('id'),
                collection: deployments,
                next_url: result.links.next
            });
            deployment_dropdown.filter = function(deployments) {
                if (deployments.type === 'draft'){
                    return true;
                } else {
                    return deployments.rel.get('devicegroup') === devicegroup;
                }
            };
            
            // Check if user can update a device group, if so, populate draft model

            if ((active.permits(primary, 'update_' + devicegroup.type)) || devicegroup.type === 'pre_dut_devicegroup'){
                deployment_dropdown.collection.unshift(devicegroup.draft);
            }
            code_info_view.showChildView('deployments_dropdown', deployment_dropdown);
        };

        return deployments.fetch({
            data: {
                'filter[devicegroup.id]': this.devicegroup.id,
                'page[size]': 10
            }
        })
        .then(show_menu);

    },
    check_syntax: function() {
        if (ga) {
            window.ga('send', 'event', 'codeEditor', 'Check Syntax');
        }
        this.ui.check_syntax.prop('disabled', true);
        this.model.check_syntax(this.devicegroup)
            .then(function(results) {
                // Show an alert
                if (results[0].length + results[1].length > 0) {
                    var errors = _.flatten(results);
                    errors.forEach(function(el, idx){

                        setTimeout(function(){
                            show_syntax_failure(el.text, el.type);
                        }, 3000 * idx);
                    });
                } else {
                    show_syntax_success();
                }

                // Trigger an event to be handled by the CodeLayoutView
                this.trigger('syntax_check', results);
                this.ui.check_syntax.prop('disabled', false);
            }.bind(this))
            .catch(function(e) {
                console.error(e);
                this.ui.check_syntax.prop('disabled', false);
            }.bind(this));
    },
    handle_syntax_messages: function(response) {
        var syntax_errors = this.model.process_syntax_check(response);
        if (syntax_errors.length) {
            // Separate agent and device code errors to match the style used by check_syntax
            var split_syntax_errors = [
                _.where(syntax_errors, { file: 'agent_code' }),
                _.where(syntax_errors, { file: 'device_code' })
            ];
            this.trigger('syntax_check', split_syntax_errors);
            show_syntax_failure();
        } else {
            // clear out any annotations that may be lingering
            var agent_session = this._parentView().editors[0].editor.getSession();
            var device_session = this._parentView().editors[1].editor.getSession();
            agent_session.clearAnnotations();
            device_session.clearAnnotations();
        }
    },
    retry_count: 0,
    create_deployment: function(action, msg){
        var devicegroup = this.devicegroup;
        var draft = this.model;
        var device = this.device;
        var agent_editor = this._parentView().editors[0].editor;
        var device_editor = this._parentView().editors[1].editor;

        // uninitialized drafts have null agent and device code;
        // before saving we should set them to strings
        this.model.set('agent_code', agent_editor.getValue());
        this.model.set('device_code', device_editor.getValue());
        alertsCh.request('showAlert', {
            messageType:'info',
            message: 'Currently Building...'
        });
        devicegroup.create_deployment(this.model)
            .then(function(deployment) {
                this.set_deployment(deployment);
                draft.save({
                    agent_code: deployment.get('agent_code'),
                    device_code: deployment.get('device_code'),
                    deployment_id: deployment.get('id'),
                });
                this.handle_syntax_messages(deployment.raw_jsonapi);
            }.bind(this))
            .then(function(){
                if (_.isFunction(action)) {
                    action();
                }
                var sha = short_sha(this.deployment.get('sha'));
                let message = 'Your deployment ( sha ' + sha  + ') has been saved, and a request was sent to deploy it onto devices in device group ' + devicegroup.get('name') + '. ';
                message ? msg = message + msg : null;
                this.set_devicegroup(devicegroup);
                this.device = device;
                this.trigger('run', devicegroup);
                alertsCh.request('showAlert', {
                    messageType: 'success',
                    message: message
                });
                this.triggerMethod('state:editable:deployment', this.deployment, this.device);
                this.retry_count = 0;
            }.bind(this),
            function(err){
                draft.save({
                    agent_code: draft.get('agent_code'),
                    device_code: draft.get('device_code'),
                    deployment_id: draft.get('id'),
                });
                let message = '';
                let title = '';
                let error;
                if (err.responseJSON &&  err.responseJSON.errors[0].status == '401' && this.retry_count < 10) {
                    this.retry_count++;
                    this.create_deployment(action, msg);
                    return;
                }
                this.handle_syntax_messages(err);
                if (err.responseJSON) {
                  error = err.responseJSON.errors[0];
                  title = error.title;
                  if ( error.code === 'CX005' && error.meta && error.meta[0] && error.meta[0].text
                       && error.meta[0].text.indexOf('invalid constant') > -1 ) {
                      message = `You have referenced an Environment Variable in your
                                 code which has not been added to this Device Group.
                                 This can be done from Device Group > Settings`;
                  }
                  alertsCh.request('response_dialog', err, 'danger', title, message);
                  return;
                }

                if ( err.responseJSON == undefined ) {
                    message = message + " Please ensure that you are connected to the internet, and then try saving your code again.";
                }
                alertsCh.request('showAlert', {
                    messageType: 'danger',
                    message: message
                });
            }.bind(this))
            .catch(this.handle_syntax_messages.bind(this));
    },
    build: function(){
        this.trigger('build');
        // Create deployment, restart none
        var msg = 'No devices requested to restarted.';
        this.create_deployment(null, msg);
    },
    build_and_deploy: function() {
        this.trigger('build');
        // Create deployment, group restart
        var msg = 'All devices requested to restart.';
        this.create_deployment(function(){
            this.devicegroup.set_minimum_deployment(this.deployment).then(this.devicegroup.restart);
        }.bind(this), msg);
    },
    build_and_conditional_deploy: function(){
        this.trigger('build');
        // Create deployment, group conditional restart
        var msg = 'Devices with handlers will manage restart.';
        this.create_deployment(this.devicegroup.conditional_restart.bind(this.devicegroup), msg);
    },
    update_timestamp: function(deployment_or_draft) {
        var primary = globalCh.request('primary_account');
        var timezone = primary.get_timezone();
        var template;
        var updated_at = Moment.utc(deployment_or_draft.get('created_at'));
        switch (this.state) {
            case 'editable_deployment':
                template = 'Deployed {{date_relative updated_on}}';
                break;
            case 'draft':
                if (updated_at.toString() === 'Invalid date') {
                    template = 'Unsaved Draft';
                } else {
                    template = 'Last saved {{date_relative created_at}}';
                }
                break;
            case 'readonly_deployment':
                template = 'Created {{date_relative created_at}}';
                break;
            default:
                template = '';
                break;
        }
        template = Handlebars.compile(template);
        var formatted_timestamp = template(deployment_or_draft.toJSON());
        var tooltip_time = updated_at;
        tooltip_time = moment(tooltip_time).tz(timezone).format('YYYY-MM-DDTHH:mm:ss Z');
        if (tooltip_time === 'Invalid date') tooltip_time = 'Draft not saved';
        this.ui.timestamp.html(formatted_timestamp);
        this.ui.timestamp.tooltip({
            title: tooltip_time,
            delay: { show: 500 }
        });
    },
    /**
     * Fetch the draft for this devicegroup and warn the user if
     * we might be overwriting it
     */
    on_click_edit: function() {
        var draft = this.devicegroup.draft;
        var copy_to_new_draft = _.bind(this.copy_to_new_draft, this);
        function create_new_draft_or_warn() {
            if (!draft.is_uninitialized()) {
                globalCh.request(
                    'showOverwriteDraftDialog',
                    copy_to_new_draft
                );
                return;
            }
            copy_to_new_draft();
        }
        draft.fetch().then(create_new_draft_or_warn).catch(create_new_draft_or_warn);
    },
    copy_to_new_draft: function() {
        var devicegroup = this.devicegroup;
        var device = this.device;
        devicegroup.draft.save({
            agent_code: this.model.get('agent_code'),
            device_code: this.model.get('device_code'),
            deployment_id: this.model.get('id'),
        }).done(function(){
            globalCh.request('showCodeEditor',
                                        devicegroup.draft,
                                        devicegroup,
                                        device);
        });
    },
    show_ide_settings: function() {
        var dialog = new IdeSettingsDialog({ model: this.options.settings });
        globalCh.request('showDialog', dialog);
    },
    set_deployment: function(deployment) {
        if (deployment) {
            if (this.model.type === 'deployment') {
                this.model = deployment;
                this.update_timestamp(deployment);
            } else {
                if (deployment.rel.get('devicegroup')) {
                    this.show_deployments_dropdown();
                }
            }
        }

        this.deployment = deployment;
        this.configure_promote_btn();
    },
    set_devicegroup: function(devicegroup) {
        this.devicegroup = devicegroup;
    },
    configure_promote_btn: function() {
        // User is editing a draft
        if (!this.deployment) {
            this.disable_promote();
            this.set_promote_tooltip('Code must be run before promotion');
            return;
        }

        // Code has already been promoted
        if (this.deployment.get('flagged')) {
            this.disable_promote();
            this.set_promote_tooltip('This code has already been promoted');
            return;
        }

        this.enable_promote();
        this.set_promote_tooltip('');
    },
    hide_buttons: function() {
        this.ui.state_editable_buttons.hide();
        this.getRegion('deployment').currentView.$el.hide();
    },
    show_buttons: function() {
        var args = Array.prototype.slice.call(arguments);
        _.each(args, function (button_name){
            this.ui[button_name].show();
            if (button_name === 'deployment_button') {
                this.getRegion('deployment').currentView.$el.show();
            }
        }, this);
    },
    enable_buttons: function () {
        var args = Array.prototype.slice.call(arguments);
        _.each(args, function (button_name) {
            this.ui[button_name].prop('disabled', false);
            if (button_name === 'deployment_button') {
                this.getRegion('deployment').currentView.disable(false);
            }
        }, this);
    },
    disable_buttons: function () {
        var args = Array.prototype.slice.call(arguments);
        _.each(args, function (button_name) {
            this.ui[button_name].prop('disabled', true);
            if (button_name === 'deployment_button') {
                this.getRegion('deployment').currentView.disable(true);
            }
        }, this);
    },
    disable_promote: function() {
        this.ui.promote.prop('disabled', true);
    },
    enable_promote: function() {
        this.ui.promote.prop('disabled', false);
    },
    set_promote_tooltip: function(message) {
        if (!message) {
            // This is necessary because Bootstrap throws an error if you
            // try and destory a nonexistent tooltip...sigh
            if (this.promote_tooltip_shown) {
                this.ui.promote_tooltip.tooltip('destroy');
                this.promote_tooltip_shown = false;
            }
            return;
        }

        // If already showing a tooltip, do this dumb workaround to change it
        if (this.promote_tooltip_shown) {
            this.ui.promote_tooltip
                .attr('title', message)
                .tooltip('fixTitle');
            return;
        }

        this.ui.promote_tooltip.tooltip({
            title: message,
            delay: { show: 1000 }
        });
        this.promote_tooltip_shown = true;
    },
    promote: function(){
        if (ga) {
            window.ga('send', 'event', 'codeEditor', 'promote');
        }
        var configure_promote_btn = this.configure_promote_btn.bind(this);
        globalCh.request('showPromoteCodeDialog', this.deployment, {
            success: function () {
                configure_promote_btn();
                alertsCh.request('showAlert', {
                    messageType: 'success',
                    message: 'Your code has been promoted and will be '
                            + 'available to deploy to production device groups.'
                });
            }
        });
    },
    toggle_fullscreen: function() {
        if (this.is_fullscreen) {
            this.triggerMethod('set_fullscreen', false);
            this.ui.toggle_fullscreen.find('.fa').removeClass('fa-compress');
            this.ui.toggle_fullscreen.find('.fa').addClass('fa-expand');
            this.is_fullscreen = false;
        } else {
            this.triggerMethod('set_fullscreen', true);
            this.ui.toggle_fullscreen.find('.fa').removeClass('fa-expand');
            this.ui.toggle_fullscreen.find('.fa').addClass('fa-compress');
            this.is_fullscreen = true;
        }
    },
    compare_shas: function(code_model){
        if (this.state === 'draft' && this.deployment && code_model) {
            // If we don't have both SHAs to compare to, it gets weird.
            if (!this.deployment.get('sha')) {
                this.deployment.fetch().then(function(){
                    this.compare_shas(code_model);
                }.bind(this));
            } else {
                // if the code model is a draft, compare it to deployment
                if (code_model.type === 'draft') {
                    // if the sha is the same, lock build button
                    if (code_model.get('sha') === this.deployment.get('sha')) {
                        this.disable_build_dropdown();
                    } else {
                        // if different, unlock the build button
                        this.enable_build_dropdown();
                    }
                } 
            }
        } else {
            this.enable_build_dropdown();
        }
    },
    enable_build_dropdown: function(){
        this.enable_buttons('deployment_button');
    },
    disable_build_dropdown: function(){
        this.disable_buttons('deployment_button');
    },
    start_code_change_listeners: function(){
        this.listenTo(this.model, 'change:agent_code', function(code_model){
            this.enable_build_dropdown();
        }.bind(this));
        this.listenTo(this.model, 'change:device_code', function(code_model){
            this.enable_build_dropdown();
        }.bind(this));
    },
    enable_editable_deployment_state: function(deployment){
        this.state = 'editable_deployment';
        // Set side-nav to "SHA" thing
        // Set top-left title text "SHA: {{sha}} (current deployment)"
        this.ui.title.html(short_sha(deployment.get('sha')));
        this.ui.title_subtext.html('<strong>(current deployment)</strong>');
        // Set top-left grey subtext to "Running since: {{deployment date}}"
        this.update_timestamp(deployment);
        // Hide all those other buttons
        this.hide_buttons();
        // Show and enable check button
        // Show and enable build and run all button
        // Show and enable promote button
        this.show_buttons('check_syntax', 'deployment_button', 'promote');
        this.disable_buttons('deployment_button');
        this.enable_buttons('check_syntax', 'promote');
    },
    enable_draft_state: function(draft){
        this.state = 'draft';
        // Set top-left title text to "last saved draft"
        this.ui.title.html('<strong>Draft</strong>');
        this.ui.title_subtext.text('');
        // Set top-left grey subtext to date of last draft save OR "unsaved draft" if none
        if (!draft.is_uninitialized()) {
            this.update_timestamp(draft);
        } else {
            this.ui.subtitle.html('<strong>Unsaved Draft</strong>');
        }
        // Hide all those other buttons
        this.hide_buttons();
        // Show and enable check button
        // Show "build and run all" button
        // Show and Disable promote button
        this.show_buttons('check_syntax', 'deployment_button', 'promote');

        // Only enable build button if draft sha is different from build sha
        this.compare_shas(draft);
        this.enable_buttons('check_syntax');
        this.disable_buttons('promote');
    },
    enable_readonly_deployment_state: function (deployment){
        this.state = 'readonly_deployment';
        var current_deployment = this.devicegroup.rel.get('current_deployment');
        // Show top top left "return to draft" link
        this.enable_return_to_draft();
        // Set top-left title text to "SHA: {{sha}" and bold post-text to either (current deployment) OR (past deployment)
        this.ui.title.html(short_sha(deployment.get('sha')));
        var text = deployment === current_deployment ? '<strong>(current deployment)</strong>' : '<strong>(past deployment)</strong>';
        this.ui.title_subtext.html(text);
        // Set top-left grey subtext to deployment_date
        this.update_timestamp(deployment);
        // Hide all those other buttons
        this.hide_buttons();
        // Show and enable edit button
        // Show and enable promote button
        this.show_buttons('edit', 'promote');
        this.enable_buttons('edit', 'promote');
    },
    enable_return_to_draft: function(draft) {
        this.ui.draft_link.show();
        this.draft = draft;
    }
});

export default CodeInfoView;

